import { Metadados } from 'common/types'
import { TCommunicationType, TUserType } from 'contexts/app-context/types'

const pfMapper: Record<TCommunicationType<'PF'>, Metadados<TUserType>['chave']> = {
  DISABLE_ALL_COMMUNICATION_CHANNELS: 'HABILITADO',
  EMAIL: 'EMAIL',
  PUSH: 'PUSH',
  SMS: 'SMS',
  WHATSAPP: 'WHATSAPP',
  PHONE: 'LIGACAO',
}

const pjMapper: Record<TCommunicationType<'PJ'>, Metadados<'PJ'>['chave']> = {
  DISABLE_ALL_COMMUNICATION_CHANNELS: 'HABILITADO',
  PUSH_SMS: 'PUSH_SMS',
  SITE_APP_EXTERNOS: 'SITE_APP_EXTERNOS',
  LIGACAO: 'LIGACAO',
  WHATSAPP: 'WHATSAPP',
  EMAIL: 'EMAIL',
}

export const brCommunicationKeyToUsCommunicationKeyMapper = <UserType extends TUserType>(
  userType: UserType,
): Record<TCommunicationType<UserType>, Metadados<UserType>['chave']> =>
  (userType === 'PJ' ? pjMapper : pfMapper) as Record<
    TCommunicationType<UserType>,
    Metadados<UserType>['chave']
  >
